import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["size"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
// DO NOT EDIT IT MANUALLY

import * as React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
var SvgKubernetesJob = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var _ref$size = _ref.size,
    size = _ref$size === void 0 ? 24 : _ref$size,
    props = _objectWithoutProperties(_ref, _excluded);
  props.width = undefined;
  props.height = undefined;
  var testId = 'icon-kubernetes-job';
  var style = {};
  var isCustomSize = typeof size === 'number';
  if (isCustomSize) {
    style.width = size + 'px';
    style.height = size + 'px';
    if (!props.style) props.style = {};
    props.style.width = size + 'px';
    props.style.height = size + 'px';
  }
  return /*#__PURE__*/_jsx("svg", _objectSpread(_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "currentColor",
    viewBox: "0 0 24 24",
    "data-test-id": testId,
    ref: ref
  }, props), {}, {
    children: /*#__PURE__*/_jsx("path", {
      fill: "inherit",
      fillRule: "evenodd",
      d: "M8.16 4.012a1155 1155 0 0 0-3.835 1.854c-.014.01-1.867 8.09-1.894 8.258-.007.044.925 1.246 2.469 3.183a879 879 0 0 0 2.671 3.342l.192.231h8.474l.192-.231c.991-1.194 5.149-6.469 5.14-6.522-.027-.166-1.881-8.252-1.894-8.261-.026-.019-7.644-3.686-7.67-3.692-.014-.003-1.744.824-3.845 1.838m7.015 1.351c1.741.838 3.177 1.535 3.191 1.55.015.015.379 1.572.81 3.461.65 2.85.775 3.445.734 3.503-.028.038-1.021 1.287-2.209 2.776l-2.159 2.707H8.458l-2.159-2.707a736 736 0 0 1-2.209-2.776c-.041-.058.083-.65.734-3.503.431-1.889.795-3.446.81-3.461.024-.025 6.329-3.07 6.361-3.072.008-.001 1.439.684 3.18 1.522M14.32 8.44v1.24h2.48V7.2h-2.48zm0 3.52v1.24h2.48v-2.48h-2.48zm-7.102-1.15c-.011.028-.014.582-.009 1.23l.011 1.18 1.25.011 1.25.01V10.76H8.479c-.962 0-1.246.011-1.261.05M10.76 12v1.24h2.48v-2.48h-2.48zM7.2 15.58v1.22h2.48v-2.44H7.2zm3.56 0v1.22h2.48v-2.44h-2.48zm3.56 0v1.22h2.48v-2.44h-2.48z"
    })
  }));
});
export default SvgKubernetesJob;